import env from 'env';
import UrlUtils from 'utils/url-utils';

export const resolveAuthReturnUrl = (returnUrl?: string | null): string => {
  if (!returnUrl) {
    return '/';
  }

  const stsAuthority = env.sts.authority;
  const appUrl = env.appUrl;

  if (returnUrl.startsWith('//')) {
    return '/';
  }

  if (returnUrl.startsWith('/connect/') && stsAuthority) {
    return UrlUtils.urlConcat(stsAuthority, returnUrl).toString();
  }

  if (returnUrl.startsWith('/')) {
    return returnUrl;
  }

  try {
    const url = new URL(returnUrl);
    const allowedOrigins = [appUrl, stsAuthority]
      .filter(Boolean)
      .map((value) => new URL(value).origin);

    if (allowedOrigins.includes(url.origin)) {
      return url.toString();
    }
  } catch {
    return '/';
  }

  return '/';
};
